/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/**
 * Root Imports
*/

import { TokenStorage } from '~/util';
import { RefreshService } from '~/services/Auth';

/**
 * Exports
*/

export const GuestContext = React.createContext({
  authenticate: null
});

export const UserContext = React.createContext({
  id: 0
});

/**
 * 
 */
export function Authenticator(props) {
  /** States **/
  
  const [ user, setUser ] = useState(null);
  const [ token, setToken ] = useState(null);
  const [ verifyingToken, setVerifyingToken ] = useState(TokenStorage.get());

  /** Side-Effects **/
  
  useEffect(() => {
    handleMount();
  }, []);

  /** Event Handlers **/

  /**
   * 
   */
  const handleMount = () => {
    if (verifyingToken) {
      handleTokenVerify();
    }
  };

  /**
   * 
   */
  const handleTokenVerify = () => {
    const config = {
      token: verifyingToken,
      tokenType: TokenStorage.type()
    };

    RefreshService(config)
      .then(response => handleAuthenticate(response.data))
      .catch(error => {
        TokenStorage.clear();
      })
      .finally(() => setVerifyingToken(null))
    ;
  };

  /**
   * 
   */
  const handleAuthenticate = ({ user, token }) => {
    setUser(user);
    setToken(token);

    TokenStorage.set(token);
  };

  /** Renderers **/

  /**
   * 
   */
  const renderVerified = () => (
    <UserContext.Provider value={{ ...user, clearToken: () => setToken(null) }}>
      {
        typeof props.verified === 'function'
          ? React.createElement(props.verified)
          : props.verified
      }
    </UserContext.Provider>
  );
  
  /**
   * 
   */
  const renderGuest = () => (
    verifyingToken ? null :
      <GuestContext.Provider value={{ authenticate: handleAuthenticate }}>
        {
          typeof props.guest === 'function'
            ? React.createElement(props.guest)
            : props.guest
        }
      </GuestContext.Provider>
  );

  /** Output **/
  
  return token ? renderVerified() : renderGuest();
}

Authenticator.propTypes = {
  guest: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]).isRequired,
  verified: PropTypes.oneOfType([ PropTypes.node, PropTypes.func ]).isRequired
};